/**
 * @param {Object} data - The delivery address data
 * @param {Array} layout - The layout to display the address in
 *
 * @returns {string} - The formatted delivery address
 */
const processLayout = (data, layout) => {
  return layout
    .map((group) => {
      return group
        .map((template) => {
          return template.replace(/\{(\w+)\}/g, (_match, key) => {
            return data[key] ?? ''
          })
        })
        .filter((value) => value && value.trim() !== '')
    })
    .filter((group) => group.length > 0)
}

/**
 * @param {Object} [data] - The delivery address data
 * @param {Object} [country] - The country data
 *
 * @returns {string | null} - The formatted delivery address or null if data is not provided
 */
export const formatDeliveryAddress = (data, country) => {
  if (!data || !country) return null

  const layout = country.show_layout.split('\n').map((part) => part.split(/\s/))
  const processedLayout = processLayout(data, layout)

  return processedLayout.flatMap((part) => part.join(' ')).join(', ')
}
